import { render, staticRenderFns } from "./InstagramFollow.vue?vue&type=template&id=34f338de&scoped=true"
import script from "./InstagramFollow.vue?vue&type=script&lang=js"
export * from "./InstagramFollow.vue?vue&type=script&lang=js"
import style0 from "./InstagramFollow.vue?vue&type=style&index=0&id=34f338de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f338de",
  null
  
)

export default component.exports